import { LocalisationConstants } from './localisation.constants'
import { LocalisationHelpers } from './localisation.helpers'

export const Localisation = {
  ...LocalisationHelpers,
  ...LocalisationConstants,
}
